export default __webpack_public_path__ + "9ccf44a2b0af75fcb1f2218eb29fdb5f.jpg";